import { ButtonBase } from '@material/mwc-button/mwc-button-base';

/**
 * @fixme [applet-framework]  it probably is a good idea to not load
 *                            mwc-button on this file, perhaps on the
 *                            shell.js would be a better place. putting
 *                            mwc-button here loads material elements before
 *                            everything else
 *
 *                            Native button elements should not be skipped as
 *                            an addition to the form submission dataset when
 *                            they
 *                            {@link https://www.w3.org/TR/html52/sec-forms.html#sec-constructing-the-form-data-set&:~:text=The%20field%20element%20is%20a%20button%20but
 *                            have a 'name' attribute}
 *                            but mwc-elements do not expose an name
 *                            attribute, until there is an issue for this or
 *                            an implementation decision is made, any button
 *                            with a name attribute will be considered a
 *                            submittable element.
 *
 *                            An related issue is mwc element integration
 *                            {@link https://github.com/material-components/material-components-web-components/issues/289
 *                            with forms}
 *
 *                            Also
 *                            {@link https://github.com/PolymerElements/iron-form/blob/672120bf1f88e57ef772bfbf3a992b1439b347ff/iron-form.js#L569
 *                            IronForm}
 *                            acknowledged the hardness of serializing
 *                            buttons,
 *                            but choose not to handle it
 */
Object.defineProperty(ButtonBase.prototype, 'name', {
  get() {
    return this.getAttribute('name');
  },
});
Object.defineProperty(ButtonBase.prototype, 'value', {
  get() {
    return this.getAttribute('value');
  },
});
